import moment from "moment";
import notification from "antd/lib/notification";
import { WDQMS_API, fetchData } from "../../utils/api";
import {
  isEmpty,
  setError404,
  getVariableID
} from "./actions";
import { setProperty, setPeriodDataKey, updatePeriodTypes } from "./actions";
import { loadInitialPeriods, loadAllPeriods } from "./action_utils";

// GBON report types
export const GBON_REPORT_TYPES = {
  gbon_synop: [
    {
      code: "availability",
      description: "Availability"
    },
    {
      code: "quality",
      description: "Quality"
    }
  ],
  gbon_temp: [
    {
      code: "availability",
      description: "Availability"
    },
    {
      code: "quality",
      description: "Quality"
    }
  ]
};

// Main GBON data fetching function for gbon_synop and gbon_temp file types
export const fetchGbonDataFromApi = (payload, pageType) => {
  // differentiate between requests coming from the map and from the database status
  if (pageType === "DB_STATUS") {
    pageType = "&page_type=DB_STATUS";
  }
  return dispatch => {
    // If we have URL params, set them to the selected
    // params for the menu and map
    if (!isEmpty(payload.params)) {
      dispatch(
        setProperty({
          type: payload.fileType,
          key: "selectedPeriodType",
          value: payload.params.periodType
        })
      );

      if (payload.params.report) {
        dispatch(
          setProperty({
            type: payload.fileType,
            key: "selectedReport",
            value: payload.params.report
          })
        );
      }
      if (payload.params.variable) {
        dispatch(
          setProperty({
            type: payload.fileType,
            key: "selectedVariable",
            value: getVariableID(payload.fileType, payload.params.variable)
          })
        );
      }

      dispatch(
        setProperty({
          type: payload.fileType,
          key: "selectedCenter",
          value: payload.params.center
        })
      );

      if (payload.params.center !== "all") {
        dispatch(
          setProperty({
            type: payload.fileType,
            key: "combinedMode",
            value: false
          })
        );
      }

      dispatch(
        setProperty({
          type: payload.fileType,
          key: "selectedDate",
          value: payload.params.date
        })
      );
    }
    if (!payload.alreadyFetched) {
      const file_type = payload.parentFileType;
      const baselineParam = "&baseline=GBON";

      // Load initial six-hour periods (quick fetch), then chain daily → monthly
      loadInitialPeriods(900, pageType, payload, "GBON", dispatch)
        .then(() => {
          // Load all six-hour periods in parallel
          loadAllPeriods(payload, pageType, "GBON").then(response => {
            dispatch(
              setPeriodDataKey({
                subObj: "periodData",
                type: payload.fileType,
                period: "six_hour",
                key: "dates",
                value: response
              })
            );
            dispatch(
              setPeriodDataKey({
                subObj: "periodData",
                type: payload.fileType,
                period: "six_hour",
                key: "centers",
                value: Object.keys(response).sort((a, b) =>
                  a.toLowerCase().localeCompare(b.toLowerCase())
                )
              })
            );
            dispatch(
              setProperty({
                type: payload.fileType,
                key: "allDataFetched",
                value: true
              })
            );
          });
        })
        .then(() => {
          // Fetch daily periods
          fetchData(
            `${WDQMS_API}/daily-periods/?file_type=${file_type}${baselineParam}${pageType}`
          )
            .then(response => {
              if (response.data.length === 0) {
                dispatch(
                  setPeriodDataKey({
                    subObj: "periodData",
                    type: payload.fileType,
                    period: "daily",
                    key: "noData",
                    value: true
                  })
                );
              } else {
                dispatch(
                  updatePeriodTypes({ type: payload.fileType, value: ["daily"] })
                );
                let tempObj = {};
                for (let p of response.data) {
                  if (!tempObj[p.center]) tempObj[p.center] = {};
                  tempObj[p.center][moment.utc(p.date).format("YYYY-MM-DD")] = { id: p.id };
                }
                let objectAll = {};
                for (let ct of Object.keys(tempObj)) {
                  for (let d of Object.keys(tempObj[ct])) {
                    if (!Object.keys(objectAll).includes(d)) objectAll[d] = {};
                    objectAll[d][ct] = tempObj[ct][d].id;
                  }
                }
                tempObj.all = objectAll;
                dispatch(
                  setPeriodDataKey({
                    subObj: "periodData",
                    type: payload.fileType,
                    period: "daily",
                    key: "dates",
                    value: tempObj
                  })
                );
                dispatch(
                  setPeriodDataKey({
                    subObj: "periodData",
                    type: payload.fileType,
                    period: "daily",
                    key: "centers",
                    value: Object.keys(tempObj).sort((a, b) =>
                      a.toLowerCase().localeCompare(b.toLowerCase())
                    )
                  })
                );
                if (!isEmpty(payload.params) && payload.params.periodType === "daily") {
                  dispatch(
                    setProperty({
                      type: payload.fileType,
                      key: "selectedCenter",
                      value: payload.params.center
                    })
                  );
                  dispatch(
                    setProperty({
                      type: payload.fileType,
                      key: "selectedDate",
                      value: tempObj[payload.params.center][payload.params.date]
                        ? payload.params.date
                        : Object.keys(tempObj[payload.params.center]).sort().pop()
                    })
                  );
                  dispatch(
                    setProperty({
                      type: payload.fileType,
                      key: "readyToFillMenu",
                      value: true
                    })
                  );
                }
              }
            })
            .catch(() => {
              if (!isEmpty(payload.params) && payload.params.periodType === "daily") {
                dispatch(setError404());
              }
              dispatch(
                setPeriodDataKey({
                  subObj: "periodData",
                  type: payload.fileType,
                  period: "daily",
                  key: "errorFetchingApi",
                  value: true
                })
              );
            });
        })
        .then(() => {
          // Fetch monthly periods (independent of daily)
          fetchData(
            `${WDQMS_API}/monthly-periods/?file_type=${file_type}${baselineParam}${pageType}`
          ).then(response => {
                if (response.data.length === 0) {
                  dispatch(
                    setPeriodDataKey({
                      subObj: "periodData",
                      type: payload.fileType,
                      period: "monthly",
                      key: "noData",
                      value: true
                    })
                  );
                } else {
                  dispatch(
                    updatePeriodTypes({ type: payload.fileType, value: ["monthly"] })
                  );
                  let tempObj = {};
                  for (let p of response.data) {
                    if (!tempObj[p.center]) tempObj[p.center] = {};
                    tempObj[p.center][moment.utc(p.date).format("YYYY-MM")] = { id: p.id };
                  }
                  let objectAll = {};
                  for (let ct of Object.keys(tempObj)) {
                    for (let d of Object.keys(tempObj[ct])) {
                      if (!Object.keys(objectAll).includes(d)) objectAll[d] = {};
                      objectAll[d][ct] = tempObj[ct][d].id;
                    }
                  }
                  tempObj.all = objectAll;
                  dispatch(
                    setPeriodDataKey({
                      subObj: "periodData",
                      type: payload.fileType,
                      period: "monthly",
                      key: "dates",
                      value: tempObj
                    })
                  );
                  dispatch(
                    setPeriodDataKey({
                      subObj: "periodData",
                      type: payload.fileType,
                      period: "monthly",
                      key: "centers",
                      value: Object.keys(tempObj).sort((a, b) =>
                        a.toLowerCase().localeCompare(b.toLowerCase())
                      )
                    })
                  );
                  if (!isEmpty(payload.params) && payload.params.periodType === "monthly") {
                    dispatch(
                      setProperty({
                        type: payload.fileType,
                        key: "selectedCenter",
                        value: payload.params.center
                      })
                    );
                    dispatch(
                      setProperty({
                        type: payload.fileType,
                        key: "selectedDate",
                        value: tempObj[payload.params.center][payload.params.date]
                          ? payload.params.date
                          : Object.keys(tempObj[payload.params.center]).sort().pop()
                      })
                    );
                    dispatch(
                      setProperty({
                        type: payload.fileType,
                        key: "readyToFillMenu",
                        value: true
                      })
                    );
                  }
                }
              })
              .catch(() => {
                if (!isEmpty(payload.params) && payload.params.periodType === "monthly") {
                  dispatch(setError404());
                }
                dispatch(
                  setPeriodDataKey({
                    subObj: "periodData",
                    type: payload.fileType,
                    period: "monthly",
                    key: "errorFetchingApi",
                    value: true
                  })
                );
              });
        });
    }
  };
};
